import { BlockLayout } from '../index.tsx';
import React from 'react';

export const getActAsProp = (arrLength, idx) => {
  if (arrLength > 1) {
    if (idx === 0) {
      return 'CardFirstChild';
    } else if (idx === arrLength - 1) {
      return 'CardLastChild';
    } else if (idx > 0 && idx < arrLength - 1) {
      return 'CardMiddleChild';
    }
  } else if (arrLength === 1) {
    return 'CardChild';
  }
};

/**
 * createCardFromList
 *
 * @param {Array} list - The array to create cards
 * @param {Function} templateFunc - The internal DOM architecture for each card
 * @param {Element} contentOnTop - The node that is placed on top of the set of cards
 * @return {HTMLElement}
 */
export function createCardFromList(list, templateFunc, contentOnTop) {
  if (Array.isArray(list) && list?.length > 0) {
    return list?.map((data, idx) => (
      <BlockLayout
        contentOnTop={idx === 0 && contentOnTop}
        key={`key_${idx}`}
        actAs={getActAsProp(list?.length, idx)}
        // showThinBottomMargin={
        //   (list?.length > 1 && idx === 0) || (idx > 0 && idx < list?.length - 1)
        //     ? true
        //     : false
        // }
        gapThruMarginOnly={(idx === list?.length - 1) ? false : true}
        isCardListChild
      >
        {templateFunc(data)}
      </BlockLayout>
    ));
  }
  return <></>;
}
